export default "__VITE_ASSET__DnhdbH7r__"